import formActionsFactory from '../../utils/formActionsFactory';
import formReducerFactory from '../../utils/formReducerFactory';
import formSelectorsFactory from '../../utils/formSelectorsFactory';
import mapper from '../mapper';
import * as constants from './constants';

const reducer = formReducerFactory(constants.NAME, mapper(constants.NAME));
const actions = formActionsFactory(constants.NAME);
const selectors = formSelectorsFactory(constants.NAME);

export default { reducer, constants, actions, selectors };
